export default __webpack_public_path__ + "static/media/appDownloadPhone.9f1674ea.png";